<template>
	<div v-if="iframe" :id="`block-${$vnode.key}`" class="c-block-list-iframe">
		<LongReadTarget
			v-if="title"
			class="relative mb-2xs/v"
			:container-id="`block-${$vnode.key}`"
			:link-to-toc="{
				name: `Spring til &quot;${title}&quot; i indholdsfortegnelsen`,
				attrs: {
					'data-focus-ignore': true,
				},
			}"
			:title="title"
			:disabled="!showTitleInToc"
		>
			<BaseH2 v-html="title" />
		</LongReadTarget>
		<CookieInformationBlocker
			:categories="
				[
					statistic && 'statistic',
					functional && 'functional',
					marketing && 'marketing',
				].filter(Boolean)
			"
		>
			<PostScribeScript
				class="c-block-list-iframe__embed"
				:html="iframe"
			/>
		</CookieInformationBlocker>
	</div>
</template>

<script>
import CookieInformationBlocker from '~/components/main/CookieInformationBlocker';
import { LongReadTarget } from '~/components/shared/LongRead';
import PostScribeScript from '~/components/shared/PostScribeScript';

export default {
	name: 'BlockListIframe',

	components: { CookieInformationBlocker, LongReadTarget, PostScribeScript },

	inheritAttrs: false,

	props: {
		title: String,
		showTitleInToc: Boolean,
		iframe: String,

		statistic: Boolean,
		functional: Boolean,
		marketing: Boolean,
	},
};
</script>

<style lang="postcss">
.c-block-list-iframe__embed {
	width: 100%;

	& > iframe {
		margin-inline: auto;
		max-width: 100%;
		aspect-ratio: 16 / 9;
	}
	& > iframe:not([width]),
	& > iframe[width=''] {
		width: 100%;
	}
}
</style>
